/**
 * Ordered zIndex to ensure proper stacking of components.
 */
export enum zIndexes {
    // Popover, modals, sidesheets, and overlay have the same z-index as we want the latest opened to be on top.
    // The latest opened will be the latest added to the #portals-root DOM div
    OVERLAY = 100,
    SIDESHEET = 100,
    POPOVER = 100,
    MODAL = 100,
    TOAST = 200,
    DRAGGED_ITEM = 300,
}
